import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { initFirebaseBackend } from './authUtils';
import { BnNgIdleService } from 'bn-ng-idle';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  NgbModule,
  NgbTooltipModule,
  NgbPopoverModule,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from '@angular/common';
import localeEnIn from '@angular/common/locales/en-IN';

import { LayoutsModule } from './layouts/layouts.module';
import { ExtrapagesModule } from './extrapages/extrapages.module';

//import { FakeBackendInterceptor } from './core/helpers/fake-backend';
import { ErrorInterceptor } from './_helper/errorInterceptor';
import { JwtInterceptor } from './_helper/jwt.interceptor';
//import { HttpRequestInterceptor } from './_helper/HttpRequestInterceptor';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { ToastrModule } from 'ngx-toastr';

import { LowerCaseUrlSerializer } from './_helper/LowerCaseUrlSerializer';
import { RouteReuseStrategy, RouterModule, UrlSerializer } from '@angular/router';
//import{HomeComponent}  from './home/home.component';

//import{SummaryComponent} from './reportsummary/summary/summary.component'
import { ConfirmationDialogComponent } from './globalComponent/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './globalComponent/confirmation-dialog/ConfirmationDialogService';
import { MatTooltip } from '@angular/material/tooltip';
import { DataService } from './service/dataService';
import { DatePipe } from '@angular/common';
import { RouterExtService } from './service/RouterExtService';

import { StoreModule } from '@ngrx/store';
import { buidReducer } from './store/buid.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { KeepAliveRouteReuseStrategy } from './apphelper/AdvancedRouteReuseStrategy';
//import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// if (environment.defaultauth === 'firebase') {
//   initFirebaseBackend(environment.firebaseConfig);
// } else {
//   FakeBackendInterceptor;
// }
export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
registerLocaleData(localeEnIn);
@NgModule({
  declarations: [AppComponent, ConfirmationDialogComponent],
  bootstrap: [AppComponent], imports: [TranslateModule.forRoot({
    defaultLanguage: 'en',
    loader: {
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [HttpClient],
    },
  }),
  StoreModule.forRoot({ buidState: buidReducer }),
  StoreDevtoolsModule.instrument({
    maxAge: 25, // Retains last 25 states
    // logOnly: environment.production // Restrict extension in prod
  }),
    RouterModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    BrowserAnimationsModule,
  ToastrModule.forRoot(),
    NgbTooltipModule,
    NgbPopoverModule,
    NgbNavModule,
    ExtrapagesModule,
    MatTooltip,
    MatCheckboxModule,
    NgbModule], providers: [
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
      {
    provide: RouteReuseStrategy,
    useClass: KeepAliveRouteReuseStrategy
  },
      // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      ConfirmationDialogService, BnNgIdleService, DatePipe, RouterExtService
      // { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
      // provideAnimationsAsync(),
      ,
      provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
